import { Layer } from "./Layer.js";

export { Folder }

/**
 * LayerTree Folders
 * 
 * @author rhess <robin.hess@awi.de>
 * @memberof vef.map.layer
 */
class Folder extends Layer {

    /**
     * Set all properties for the layer based on the options object.
     * 
     * @param {object} config 
     * @param {object} cache 
     * @param {string} id 
     */
    constructor(config, cache, id) {
        // calling parent constructor
        super(config, cache, id);

        // init default values and define getters and setters
        this.addDefaults_({
            icon: "fas fa-folder"
        });

        this.setAll_("type", "folder");
    }
}
